

























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'ui-pagination',
})
export default class UiPaginationComponent extends Vue {
  @Prop({ default: 1 }) current: number;
  @Prop({ default: 10 }) size: number;
  @Prop({
    default: function () {
      return [10, 25, 50, 100];
    },
  })
  rowCountsArray: Array<number>;
  @Prop({ default: true }) showAllSelect: Boolean;
  @Prop({ default: 'default', type: String }) theme: string;
  @Prop({ type: Number }) count: number;
  @Prop({ default: true }) showtext: Boolean;
  @Prop({ default: false }) entriesOnThePage: Boolean;
  //#21324f

  currentPage: number = this.current;
  page = 1;
  pages = [1];
  selectedCountOnPage: number = this.size || this.rowCountsArray[0] || 10;

  rowCountsSelect = this.rowCountsArray;

  // @Watch("startPage")
  // onChangeStartPage(){
  //   this.currentPage=this.startPage
  // }
  @Watch('countOnPage')
  countPages(): number {
    if (!this.selectedCountOnPage) return 1;
    return Math.ceil(this.count / this.selectedCountOnPage);
  }
  @Watch('count')
  onChangeCount() {
    this.onUpdateData(this.count);
    //  this.count = this.counts;
  }

  created() {
    this.onUpdateData(this.count);
  }
  mounted() {
    this.currentPage = this.current;
  }
  beforeDestroy() {}

  onUpdateData(data: number) {
    // console.log("пагинация onUpdateData", data)
    this.page = data;

    if (this.currentPage > this.countPages()) this.currentPage = this.countPages();
    if (this.currentPage == 0 && this.countPages() > 0) this.currentPage = 1;
    var p = [];
    for (var i = 1; i <= this.countPages(); i++) p.push(i);
    this.pages = p;
  }

  changePage(page: any) {
    if (this.selectedCountOnPage != this.size) {
      this.$emit('onChange', this.getRequest());
    }
    if (this.currentPage === page) return;
    if (!this.selectedCountOnPage) this.currentPage = 1;
    if (page < 1 || (page - 1) * this.selectedCountOnPage >= this.count) return;
    this.currentPage = page;

    this.$emit('onChange', this.getRequest());
  }
  resetCount() {
    this.currentPage = 1;
    this.$emit('onChange', this.getRequest());
  }

  getRequest() {
    if (!this.selectedCountOnPage) return {};
    // console.log({ Page: this.currentPage, CountOnPage: this.selectedCountOnPage })
    return { Page: this.currentPage, CountOnPage: this.selectedCountOnPage };
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-table/src/ui-pagination.vue